import { render, staticRenderFns } from "./WidgetBig.vue?vue&type=template&id=f45d3eba&scoped=true"
import script from "./WidgetBig.vue?vue&type=script&lang=js"
export * from "./WidgetBig.vue?vue&type=script&lang=js"
import style0 from "./WidgetBig.vue?vue&type=style&index=0&id=f45d3eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45d3eba",
  null
  
)

export default component.exports